<template>
    <Mikomi_Type_Game v-for="keikaku in MikomiMonthData.Keikaku" :key="keikaku" :Team="Team" :MikomiTypeData="keikaku.Data" :CellTitlePrefix="KeikakuCellTitlePrefix(keikaku)" :CellColor="KeikakuCellColor(keikaku)" />
    <template v-if="MikomiMonthData.Month >= CurrentMonth">
        <Mikomi_Type_Game :Team="Team" :MikomiTypeData="MikomiMonthData.Estimation" :CellTitlePrefix="'見込 '" :CellColor="'#DAEEF3'" />
    </template>
    <template v-else>
        <Mikomi_Type_Game :Team="Team" :MikomiTypeData="MikomiMonthData.Result" :CellTitlePrefix="'実績 '" :CellColor="'#DAEEF3'" />
    </template>
    <Mikomi_Type_Game :Team="Team" :MikomiTypeData="MikomiMonthData.Difference" :CellTitlePrefix="'差額 '" :CellColor="'#FFFFFF'" />
    <div style="margin-right: 1px;"></div>
</template>

<script>
import Mikomi_Type_Game from './Mikomi_Type_Game.vue';
export default{
    components:{
        Mikomi_Type_Game,
    },
    props:{
        MikomiMonthData: Object,
        CurrentMonth: Number,
        Team: String,
    },
    methods:{
        KeikakuCellTitlePrefix(keikaku)
        {
            switch(keikaku.Revision)
            {
                case 0: return '計画 ';
                case 1: return '3月見直計画 ';
                case 2: return '6月見直計画 ';
                case 3: return '9月見直計画 ';
                default: return '';
            } 
        },
        KeikakuCellColor(keikaku)
        {
            switch(keikaku.Revision)
            {
                case 0: return '#D8E4BC';
                case 1: return '#FDE9D9';
                case 2: return '#E4DFEC';
                case 3: return '#FFFF99';

                default: '#FF9900';
            } 
        },
    },
    // mounted(){
    //     if (this.MikomiMonthData.Month === 1)
    //     {
    //         console.log(`[Mikomi_Month_Game] ${this.Team} ${this.MikomiMonthData.Month}月`, this.MikomiMonthData);
    //     }
    // }
}
</script>